export const NavBarFacilityDetailsHelper = (phoneNumber: string) => {
  let phoneNumberRedirect: string = '';
  if (phoneNumber) {
    phoneNumberRedirect = `tel:${phoneNumber.replace(/[^a-zA-Z0-9]/g, '')}`;
  }

  return phoneNumberRedirect;
};
